import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Dashboard from "../pages/dashboard/page";
import Community from "../pages/community/page";
import PartyPage from "../pages/party/page";
import LearningPage from "../pages/learning/page";
import PricingPage from "../pages/pricing/page";
import ExplorePage from "../pages/explore/page";
import LearnPage from "../pages/learn/page";
import FeedPage from "../pages/feed/page";
import RoadmapPage from "../pages/roadmap/page";
import NotebookPage from "../pages/notebook/page";
import PortfolioPage from "../pages/portfolio/page";
import JournalPage from "../pages/journal/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/dashboard", element: <Dashboard /> },
  { path: "/community", element: <Community /> },
  { path: "/party", element: <PartyPage /> },
  { path: "/learning", element: <LearningPage /> },
  { path: "/pricing", element: <PricingPage /> },
  { path: "/explore", element: <ExplorePage /> },
  { path: "/learn/:id", element: <LearnPage /> },
  { path: "/feed", element: <FeedPage /> },
  { path: "/roadmap", element: <RoadmapPage /> },
  { path: "/notebook", element: <NotebookPage /> },
  { path: "/portfolio", element: <PortfolioPage /> },
  { path: "/journal", element: <JournalPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
